import { numberToABC } from '@doltech/utils/lib/text';
import { isNumber } from 'lodash';
import { getSnapshot, Instance, types as t } from 'mobx-state-tree';

import { DragIn } from '../../../question-data-model/Question/_implementations/drag-in.store';
import { CorrectOption } from '../../../question-data-model/Question/CorrectOption/correct-option.store';
import { ExtraQuestionProps } from '../../components/questions/BaseQuestion';
import { ResultTestQuestionStore } from '../result-test-question.store';

export const ResultDragInQuestion = t
  .compose(ResultTestQuestionStore, DragIn)
  .props({
    correctOptions: t.array(CorrectOption),
  })
  .named('ResultDragInQuestion')
  .views((self) => ({
    get questionCount() {
      return self.questions.length;
    },

    getQuestions() {
      return self.correctOptions.map((correctOption, index) => {
        const userAnswer = self.userAnswers.find((_, uaIndex) => uaIndex === index);
        const extraProps: ExtraQuestionProps = {
          no: self.no + index,
          correction: correctOption,
          markedStatus: self.marked[index],
          userAnswer,
          corrections: self.correctOptions,
          userAnswerKey:
            self.userAnswers && isNumber(userAnswer) ? numberToABC(userAnswer + 1) : undefined,
          correctAnswerKey: numberToABC(correctOption.key + 1),
          index,
        };
        return {
          ...getSnapshot(self),
          ...extraProps,
        };
      });
    },
  }));

export interface ResultDragInQuestionInstance extends Instance<typeof ResultDragInQuestion> {}
